import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import NextIcon from 'assets/icons/next.svg';
import moment from 'moment';
import { BUYER_CLASSIFICATION, SELLER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { TooltipText } from 'presentation/components/TooltipText';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { COMMON, TODO_CLASS } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { CardData } from '../models/CardModel';
import { useBuildingAge } from 'hook/useBuildingAge';

interface props {
    data: CardData;
    type: number;
}
export const CardComponent = ({ data, type }: props) => {
    const navigate = useNavigate();
    const getAddressText = (data: CardData) => {
        const result = data?.residence ?? '';
        return result.trim() === '' ? COMMON.EMPTY : result;
    };
    const SCU00203T1 = [
        '0001000010',
        '0001000020',
        '0001000030',
        '0001000040',
        '0001000050',
        '0001000060',
        '0001000070',
    ];
    const state = {
        currentTodo: data.currentTodo,
        memberTodo: data.memberTodo,
        bidPrice: data.bidPrice,
        name: data.name,
        purchaseAmount: data.purchaseAmount * 100,
    };

    const buildingAge = data?.builtAt ? useBuildingAge({ builtAt: data?.builtAt }) : COMMON.EMPTY; // 築年数の計算

    const onClickViewDetail = (propertyId: number, listedPropertyId: number, auctionId: number) => {
        if (type == BUYER_CLASSIFICATION) {
            navigate(
                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_009_01}/${listedPropertyId}?type=${type}${(data.settlementId && `&settlementId=${data.settlementId}`) || ''}&dealId=${data.dealId}`,
            );
        } else {
            if (SCU00203T1.includes(data.currentTodo.todoCode)) {
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_03}/${listedPropertyId}/${propertyId}/${(auctionId && auctionId) || ''}?tabIndex=0&type=${type}${(data.settlementId && `&settlementId=${data.settlementId}`) || ''}&dealId=${data.dealId}`,
                    {
                        state: {
                            ...state,
                            brokerageContractFile: data.brokerageContractFile,
                            agencyContractFile: data.brokerageContractFile,
                            leaseContractFile: data.leaseContractFile,
                            propertyContractFile: data.propertyContractFile,
                        },
                    },
                );
            } else {
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_03}/${listedPropertyId}/${propertyId}/${(auctionId && auctionId) || ''}?tabIndex=0&type=${type}${(data.settlementId && `&settlementId=${data.settlementId}`) || ''}&dealId=${data.dealId}`,
                    { state: state },
                );
            }
        }
    };
    return (
        <section
            className="card-element button-style glow-on-hover"
            onClick={() =>
                onClickViewDetail(data.propertyId, data.listedPropertyId, data.auctionId)
            }
        >
            {type != BUYER_CLASSIFICATION && (
                <section className="font-[700] text-[#28323c]">
                    {data?.currentTodo?.todoClassName} &nbsp;
                </section>
            )}
            <div style={{ width: '100%', height: 143, marginBottom: 24 }}>
                <ImageComponent alt="" width={231} height={143} src={data?.image} />
            </div>
            <section
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}
            >
                <div style={{ textAlign: 'left' }}>
                    <div className="todo-message" style={{ marginBottom: 9, width: '195px', height: '33px'}}>
                        <TooltipText
                            content={data?.currentTodo?.todoMessage01 ?? data?.memberTodo[0]?.todoMessage01 ?? COMMON.EMPTY}
                            maxLine={3}
                        />
                    </div>
                    <div className="title" style={{ marginBottom: 9, width: '195px' }}>
                        <TooltipText
                            content={
                                data?.name 
                                ? `${data.name}${data?.roomNumber ?? ''}` 
                                : COMMON.EMPTY
                            }
                            maxLine={2}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <div className="content" style={{ width: '195px' }}>
                            {(type == BUYER_CLASSIFICATION && (
                                <TooltipText
                                    content={`即決価格${commonHelpers.roundTenThousandYenFormat(data.askingSalePriceUpperLimit)}万円`}
                                    maxLine={2}
                                />
                            )) || (
                                <Tooltip
                                    title={`${commonHelpers.roundTenThousandYenFormat(data.marketPrice)}万円`}
                                    color={'#ffffff'}
                                >
                                    <span className={'tooltip-text'} style={{ WebkitLineClamp: 1 }}>
                                        <strong
                                            style={{ fontSize: 14 }}
                                        >{`${commonHelpers.roundTenThousandYenFormat(data.marketPrice)}万円`}</strong>{' '}
                                        {['0001000060', '0001000070'].includes(
                                            data?.currentTodo?.todoCode,
                                        )
                                            ? '相場価格'
                                            : '仮相場価格'}
                                    </span>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    {type == SELLER_CLASSIFICATION &&
                            (data?.currentTodo?.todoClassId == TODO_CLASS.UNDER_ASSESSMENT || data?.currentTodo?.todoClassId == TODO_CLASS.DONE_ASSESSMENT) && (
                                <div className="content" style={{ width: '195px' }}>
                                    <Tooltip
                                        title={`${commonHelpers.roundTenThousandYenFormat(data.askingSalePrice)}万円`}
                                        color={'#ffffff'}
                                    >
                                        <span className={'tooltip-text'} style={{ WebkitLineClamp: 1 }}>
                                            <strong
                                                style={{ fontSize: 14 }}
                                            >{`${commonHelpers.roundTenThousandYenFormat(data.askingSalePrice)}万円`}</strong>{' '}
                                            売却希望価格
                                        </span>
                                    </Tooltip>
                                </div>
                            )}
                    {type == BUYER_CLASSIFICATION && (
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                            <div className="content" style={{ width: '185px' }}>
                                <TooltipText content={getAddressText(data)} maxLine={2} />
                            </div>
                        </div>
                    )}

                    {type == BUYER_CLASSIFICATION && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="content">
                                {`${buildingAge} ${data.occupiedArea || 0}`}{' '}
                                m<sup style={{ fontSize: 7 }}>2</sup>
                            </div>
                        </div>
                    )}
                    {type != BUYER_CLASSIFICATION && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                            }}
                        >
                            {data?.currentTodo && data?.currentTodo.todoName && (
                                <div className="content">
                                    <CheckCircleFilled
                                        style={{
                                            fontSize: 14,
                                            opacity:
                                                data.currentTodo.todoExecStatus == 'DONE'
                                                    ? 'unset'
                                                    : 0.3,
                                            width: 20,
                                            color:
                                                data.currentTodo.todoExecStatus == 'DONE'
                                                    ? '#1F8DDD'
                                                    : 'unset',
                                        }}
                                    />
                                    {data?.currentTodo.todoName}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="button-style">
                    <img alt="" src={NextIcon} />
                </div>
            </section>
        </section>
    );
};
